import { useTranslation } from "react-i18next";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import CottageRoundedIcon from "@mui/icons-material/CottageRounded";
import ForestRoundedIcon from "@mui/icons-material/ForestRounded";
import ViewHeadlineRoundedIcon from "@mui/icons-material/ViewHeadlineRounded";
import {
  BottomNavigation,
  BottomNavigationAction,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from "@mui/material";

import { useComposeFlow } from "@/components/compose";
import { FeaturesHooks } from "@/hooks";
import { BottomNavigationActionMenu } from "@/primitives/BottomNavigationActionMenu";
import { JobsQueries } from "@/queries";
import { AppRoutes } from "@/routes";

export const Navigation = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { canCompose, canSeeAllStoriesFromAllUsers } =
    FeaturesHooks.useFeatureFlags();

  const { composeFlow, enterCompose } = useComposeFlow();
  // One job at a time — the compose action drops out of the nav while anything
  // is in flight, the same way iOS drops the toolbar `+`.
  const hasActiveJob = JobsQueries.useHasActiveJob();

  return (
    <>
      <BottomNavigation showLabels value={pathname}>
        {canSeeAllStoriesFromAllUsers ? (
          <BottomNavigationActionMenu
            menuProps={{
              anchorOrigin: { horizontal: "center", vertical: "top" },
              transformOrigin: { horizontal: "center", vertical: "bottom" },
            }}
            menu={
              <MenuItem component={RouterLink} to={AppRoutes.STORIES()}>
                <ListItemIcon>
                  <ViewHeadlineRoundedIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText primary={t("app.areas.allStories.navItem")} />
              </MenuItem>
            }
            onClick={() => navigate(AppRoutes.HOME())}
            component={RouterLink}
            icon={
              <Tooltip title={t("app.areas.stories.navItem")}>
                <ForestRoundedIcon
                  color={pathname === AppRoutes.HOME() ? "primary" : "inherit"}
                />
              </Tooltip>
            }
            value={AppRoutes.HOME()}
          />
        ) : (
          <BottomNavigationAction
            component={RouterLink}
            icon={
              <Tooltip title={t("app.areas.stories.navItem")}>
                <ForestRoundedIcon
                  color={pathname === AppRoutes.HOME() ? "primary" : "inherit"}
                />
              </Tooltip>
            }
            to={AppRoutes.HOME()}
            value={AppRoutes.HOME()}
          />
        )}
        {canCompose && !hasActiveJob ? (
          <BottomNavigationAction
            icon={<AutoFixHighRoundedIcon color="primary" />}
            label={t("app.flows.compose.navItem")}
            onClick={enterCompose}
            sx={{ gap: 0.5 }}
          />
        ) : null}
        <BottomNavigationAction
          component={RouterLink}
          icon={
            <Tooltip title={t("app.areas.library.navItem")}>
              <CottageRoundedIcon
                color={pathname === AppRoutes.LIBRARY() ? "primary" : "inherit"}
              />
            </Tooltip>
          }
          to={AppRoutes.LIBRARY()}
          value={AppRoutes.LIBRARY()}
        />
      </BottomNavigation>
      {composeFlow}
    </>
  );
};
